import {
  SET_BRANCHES
  SET_CURRENT_BRANCH
} from './actionTypes'

export setCurrentBranch = (branch) ->
  type: SET_CURRENT_BRANCH
  payload: { data: branch }

export setBranches = (branches) ->
  type: SET_BRANCHES
  payload: { data: branches }
